import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import BasicShapesContainer from "./BasicShapesContainer";
import AuthContext from "../../../../context/userAuth.context";
import MyContext from "../../../../context/MyContext";
import ShapesAndProps from "../Assets/ShapesAndProps";
import AssetPropSearch from "../../../../Search/AssetPropSearch";
import loader from "../../../../assets/Loader/AssetLoader.json";
import Lottie from "react-lottie";
import Shape from "../../SUBcomponents/Assets/Shapes";
import AssetSearch from "../../../../Search/AssetSearch";
//file updated
export const ShapesWrapper = (props) => {
  const [ShowBasicShapes, setShowBasicShapes] = useState(false);
  const { authenticationData } = useContext(AuthContext);
  const [categoryList, setcategoryList] = useState([]);
  const { BasicShapes, setBasicShapes, setisTextInputOrAreaFocus } =
    useContext(MyContext);
  const [currentCategoryId, setcurrentCategoryId] = useState(0);
  const [ActiveTab, setActiveTab] = useState("Shapes");
  const [propsFolder, setPropsFolder] = useState([]);
  const [propGlobal, setpropGlobal] = useState(false);
  const [searchPropFolder, setSearchPropFolder] = useState([]);
  const [isPropSearch, setIsPropSearch] = useState(false);
  const [isShapeSearch, setIsShapeSearch] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const [MyLoader, setMyLoader] = useState(true);
  const [ShapesFolder, SetShapesFolder] = useState([]);
  const [searchFolder, setSearchFolder] = useState([]);

  useEffect(() => {
    GetShapesCategoriesList();
    getPropsFolderData();
    getObjectFolderData();
  }, []);

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  async function getObjectFolderDataBykeyword(keyword) {
    let formdata = new FormData();
    formdata.append("keyword", keyword);
    axios
      .post(
        authenticationData.ApiBaseURL +
          "/api/Administration/getObjectFolderDataBykeyword",
        formdata,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setSearchFolder([]);
        setSearchFolder([...response.data.response]);
      });
  }

  async function getShapesFolderDataBykeyword(keyword) {
    let formdata = new FormData();
    formdata.append("keyword", keyword);
    axios
      .post(
        authenticationData.ApiBaseURL +
          "/api/Administration/getShapesFolderDataBykeyword",
        formdata,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setSearchFolder([]);
        setSearchFolder([...response.data.response]);
      });
  }

  const SearchAsset = (e) => {
    if (e.keyCode === 13) {
      if (searchKeyword == "") {
        setIsSearch(false);
        setIsPropSearch(false);
        setIsShapeSearch(false);
        return;
      }

      e.preventDefault();
      if (ActiveTab == "Objects") {
        //alert(ActiveTab)
        setIsSearch(true);
        getObjectFolderDataBykeyword(searchKeyword);
      } else if (ActiveTab == "Props") {
        setIsPropSearch(true);
        getPropFolderDataBykeyword(searchKeyword);
      } else if (ActiveTab == "Shapes") {
        setIsShapeSearch(true);
        getShapesFolderDataBykeyword(searchKeyword);
      }
    } else {
      setIsSearch(false);
      setIsPropSearch(false);
      setIsShapeSearch(false);
    }
  };
  async function getPropsFolderData() {
    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Administration/getPropsFolderData",
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setPropsFolder([...response.data.response]);
        setMyLoader(false);
      });
  }

  async function getObjectFolderData() {
    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Administration/getObjectFolderData",
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        SetShapesFolder([...response.data.response]);
      });
  }
  async function getPropFolderDataBykeyword(keyword) {
    let formdata = new FormData();
    formdata.append("keyword", keyword);
    axios
      .post(
        authenticationData.ApiBaseURL +
          "/api/Administration/getPropFolderDataBykeyword",
        formdata,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setSearchPropFolder([]);
        setSearchPropFolder([...response.data.response]);
      });
  }

  const GetShapesCategoriesList = () => {
    setShowBasicShapes(ShowBasicShapes);
    axios
      .get(
        authenticationData.ApiBaseURL + "/api/Shapes/GetShapesCategoriesList",
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setcategoryList([...response.data.shapesCategories]);
      })
      .catch((err) => {});
  };

  const getShapesByCategory = (e) => {
    setShowBasicShapes(!ShowBasicShapes);
    setcurrentCategoryId(e.currentTarget.id);
    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Shapes/GetShapesByCategory?categoryId=" +
          e.currentTarget.id +
          "",
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setBasicShapes(response.data.shapes);
      })
      .catch((err) => {});
  };

  return (
    <>
      <div className="divLabel mb-3">Shapes</div>
      <div className="tabs mb-2">
        <div className="p2">
          <div
            className={
              "tabButton" + (ActiveTab === "Shapes" ? " activeTab" : "")
            }
            onClick={() => {
              setActiveTab("Shapes");
            }}
          >
            Shapes
          </div>
          <div
            className={
              "tabButton" + (ActiveTab === "Props" ? " activeTab" : "")
            }
            onClick={() => {
              setActiveTab("Props");
            }}
          >
            Props
          </div>
          <div
            className={
              "tabButton" + (ActiveTab === "Objects" ? " activeTab" : "")
            }
            onClick={() => {
              setActiveTab("Objects");
            }}
          >
            Objects
          </div>
        </div>
      </div>
      {ActiveTab != "Characters" && (
        <div className="searchBarParent" style={{ padding: "0px 12px" }}>
          <span className="material-icons SearchIconCustom">search</span>
          <input
            multiple
            type="text"
            onKeyUp={(e) => SearchAsset(e)}
            value={searchKeyword}
            onChange={(e) => {
              setSearchKeyword(e.target.value);
              setIsPropSearch(false);
            }}
            className="search customInput searchpad"
            placeholder="Search Here ..."
            onFocus={() => setisTextInputOrAreaFocus(true)}
            onBlur={() => setisTextInputOrAreaFocus(false)}
          />
        </div>
      )}
      <div
        className="assetsScrol style-1"
        style={{ height: "calc(100% - 160px)" }}
      >
        {categoryList.length > 0 &&
          !isShapeSearch &&
          ActiveTab == "Shapes" &&
          categoryList.map((item) => {
            if (item.id == currentCategoryId) {
              return (
                <BasicShapesContainer
                  BasicShapes={BasicShapes}
                  getShapesByCategory={getShapesByCategory}
                  item={item}
                  ShowBasicShapes={ShowBasicShapes}
                />
              );
            } else {
              return (
                <BasicShapesContainer
                  BasicShapes={BasicShapes}
                  getShapesByCategory={getShapesByCategory}
                  item={item}
                  ShowBasicShapes={false}
                />
              );
            }
          })}

        {ActiveTab === "Props" && isPropSearch && (
          <AssetPropSearch
            getPropFolderDataBykeyword={getPropFolderDataBykeyword}
            searchKeyword={searchKeyword}
            item={searchPropFolder}
          />
        )}

        {ActiveTab === "Objects" && isSearch && (
          <AssetSearch
            getObjectFolderDataBykeyword={getObjectFolderDataBykeyword}
            searchKeyword={searchKeyword}
            item={searchFolder}
            type={"Objects"}
          />
        )}

        {ActiveTab === "Shapes" && isShapeSearch && (
          <AssetSearch
            getObjectFolderDataBykeyword={getShapesFolderDataBykeyword}
            searchKeyword={searchKeyword}
            item={searchFolder}
            type={"Shapes"}
          />
        )}

        {ActiveTab == "Props" && propsFolder.length > 0
          ? propsFolder.map((lmc, index) => (
              <ShapesAndProps
                getPropsFolderData={getPropsFolderData}
                skey={"props" + index}
                name={lmc.text}
                icon={lmc.icon}
                path={lmc.path}
                item={lmc.items}
                indexes={index}
                propGlobal={propGlobal}
                setpropGlobal={setpropGlobal}
              />
            ))
          : MyLoader && (
              <Lottie
                options={{ loop: true, autoplay: true, animationData: loader }}
                height={200}
                width={200}
                isStopped={false}
                isPaused={false}
              />
            )}

        {ActiveTab == "Objects" && ShapesFolder.length > 0
          ? ShapesFolder.map((lmc, index) => (
              <Shape
                getObjectFolderData={getObjectFolderData}
                key={"shapes" + index}
                item={lmc.items}
                path={lmc.path}
                name={lmc.text}
              />
            ))
          : MyLoader && (
              <Lottie
                options={{ loop: true, autoplay: true, animationData: loader }}
                height={200}
                width={200}
                isStopped={false}
                isPaused={false}
              />
            )}
      </div>
    </>
  );
};
export default ShapesWrapper;
